<template>
    <span class="wabident-teeth-selector">
        <v-select v-if="!lock" multiple class="wabident-selector wabident-selector__small" :filterable="true"
            :options="teeth_options" placeholder="" @input="change" v-model="selected_teeth"></v-select>
        <div v-else>
            {{ selected_teeth_text }}
            <i class="fas fa-lock"
                v-b-popover.hover.top="'Edita directamente el tratamiento si quieres cambiar las piezas.'"
                title="LINEA BLOQUEADA"></i>
        </div>
    </span>
</template>

<script>
export default {
    props: ['value', 'lock'],
    data() {
        return {
            selected_teeth: [],
            teeth: [
                // Adultos
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                31,
                32,
                33,
                34,
                35,
                36,
                37,
                38,
                41,
                42,
                43,
                44,
                45,
                46,
                47,
                48,
                // Niños
                51,
                52,
                53,
                54,
                55,
                61,
                62,
                63,
                64,
                65,
                71,
                72,
                73,
                74,
                75,
                81,
                82,
                83,
                84,
                85,
            ]
        }
    },
    computed: {
        selected_teeth_text() {
            if (!this.selected_teeth || !this.selected_teeth.length) {
                return '';
            }
            return '(' + this.selected_teeth.map((t) => {
                return t;
            }).join(',') + ')';
        },
        teeth_options() {
            return this.teeth.map((t) => {
                return {
                    label: String(t),
                    value: t
                }
            });
        }
    },
    methods: {
        change(val) {
            this.$emit('input', val.map((x) => x.value));
        },
    },
    mounted() {
        this.selected_teeth = this.value;
    }
}
</script>

<style lang="scss">
.wabident-teeth-selector {
    display: inline-block;
}
</style>